export const progressStatuses = ['progress', 'pending']